import React from 'react'
import { useForm } from "react-hook-form";

const SearchComponent = (props) => {

    const { register, handleSubmit, watch, formState: { errors } } = useForm();
    return (
        <>
            <div class="search-panel">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 search-container">
                  <div class="col-12 col-sm-12 col-md-12 col-lg-11 search-text">
                    <input
                      type="text"
                      name="searchKeyword"
                      value={props.searchKeyword.value}
                      onChange={props.handleChanges}
                      placeholder={props.context.t("CurrentActivity.Search.by.Name.Text")}
                      className="form-control" />
                  </div>
                  <div class="search-text">
                    <a
                      id="ers-search"
                      tabIndex="0"
                      onClick={props.onSearch}
                      className="btn btn-search"
                    >
                      {props.context.t("CurrentActivity.Search.Text")}
                    </a>
                  </div>
                </div>
              </div>
        </>
    );
};
export default SearchComponent;
